var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
/* eslint-disable wc/no-self-class */
// TODO: Remove previous line and work through no-self-class issues at next edit
import { LitElement } from 'lit';
import { html } from 'lit-html';
import { property } from 'lit/decorators.js';
import styles from './shs-datepicker-item.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsDatePickerItem = (() => {
    var _SdsDatePickerItem_identifier_accessor_storage, _SdsDatePickerItem_value_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-datepicker-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _set_current_decorators;
    let _set_unavailable_decorators;
    let _set_state_decorators;
    var SdsDatePickerItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDatePickerItem_identifier_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _identifier_initializers, void 0)));
            _SdsDatePickerItem_value_accessor_storage.set(this, (__runInitializers(this, _identifier_extraInitializers), __runInitializers(this, _value_initializers, void 0)));
            this._current = __runInitializers(this, _value_extraInitializers);
            this._state = 'none';
        }
        get identifier() { return __classPrivateFieldGet(this, _SdsDatePickerItem_identifier_accessor_storage, "f"); }
        set identifier(value) { __classPrivateFieldSet(this, _SdsDatePickerItem_identifier_accessor_storage, value, "f"); }
        get value() { return __classPrivateFieldGet(this, _SdsDatePickerItem_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsDatePickerItem_value_accessor_storage, value, "f"); }
        get current() {
            return this._current;
        }
        set current(isCurrent) {
            if (isCurrent) {
                this.classList.add('sds-date-picker-item--current');
            }
            else {
                this.classList.remove('sds-date-picker-item--current');
            }
            this._current = isCurrent;
        }
        get unavailable() {
            return this._unavailable;
        }
        set unavailable(isUnavailable) {
            if (isUnavailable) {
                this.classList.add('sds-date-picker-item--unavailable');
            }
            else {
                this.classList.remove('sds-date-picker-item--unavailable');
            }
            this._unavailable = isUnavailable;
        }
        get state() {
            return this._state;
        }
        set state(state) {
            switch (state) {
                case 'selected':
                    this.classList.add('sds-date-picker-item--selected');
                    this.classList.remove('sds-date-picker-item--sub-selected');
                    this.classList.remove('sds-date-picker-item--range');
                    this.classList.remove('sds-date-picker-item--range-hover');
                    break;
                case 'sub-selected':
                    this.classList.add('sds-date-picker-item--sub-selected');
                    this.classList.remove('sds-date-picker-item--selected');
                    this.classList.remove('sds-date-picker-item--range');
                    this.classList.remove('sds-date-picker-item--range-hover');
                    break;
                case 'range-hover':
                    this.classList.add('sds-date-picker-item--range-hover');
                    break;
                case 'range':
                    this.classList.add('sds-date-picker-item--range');
                    this.classList.remove('sds-date-picker-item--sub-selected');
                    this.classList.remove('sds-date-picker-item--selected');
                    this.classList.remove('sds-date-picker-item--range-hover');
                    break;
                case 'none':
                    this.classList.remove('sds-date-picker-item--selected');
                    this.classList.remove('sds-date-picker-item--sub-selected');
                    this.classList.remove('sds-date-picker-item--range');
                    this.classList.remove('sds-date-picker-item--range-hover');
                    break;
            }
            this._state = state;
        }
        render() {
            return html ` <div class="sds-date-picker-item-inner">
            ${this.value}
            <slot name="description" class="sds-date-picker-item-inner__desc"></slot>
        </div>`;
        }
    };
    _SdsDatePickerItem_identifier_accessor_storage = new WeakMap();
    _SdsDatePickerItem_value_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDatePickerItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _identifier_decorators = [property()];
        _value_decorators = [property({ type: String })];
        _set_current_decorators = [property({ type: Boolean })];
        _set_unavailable_decorators = [property({ type: Boolean })];
        _set_state_decorators = [property()];
        __esDecorate(_classThis, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _set_current_decorators, { kind: "setter", name: "current", static: false, private: false, access: { has: obj => "current" in obj, set: (obj, value) => { obj.current = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_unavailable_decorators, { kind: "setter", name: "unavailable", static: false, private: false, access: { has: obj => "unavailable" in obj, set: (obj, value) => { obj.unavailable = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_state_decorators, { kind: "setter", name: "state", static: false, private: false, access: { has: obj => "state" in obj, set: (obj, value) => { obj.state = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDatePickerItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDatePickerItem = _classThis;
})();
export { SdsDatePickerItem };
